module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-097f716891c20aeb716364abbdbbb844.webp";